const VerticalDots = () => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 6 32"
        width="6"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="1" cy="2" fill="#888888" r="1" />
        <circle cx="5" cy="2" fill="#888888" r="1" />
        <circle cx="1" cy="6" fill="#888888" r="1" />
        <circle cx="5" cy="6" fill="#888888" r="1" />
        <circle cx="1" cy="10" fill="#888888" r="1" />
        <circle cx="5" cy="10" fill="#888888" r="1" />
        <circle cx="1" cy="14" fill="#888888" r="1" />
        <circle cx="5" cy="14" fill="#888888" r="1" />
        <circle cx="1" cy="18" fill="#888888" r="1" />
        <circle cx="5" cy="18" fill="#888888" r="1" />
        <circle cx="1" cy="22" fill="#888888" r="1" />
        <circle cx="5" cy="22" fill="#888888" r="1" />
        <circle cx="1" cy="26" fill="#888888" r="1" />
        <circle cx="5" cy="26" fill="#888888" r="1" />
        <circle cx="1" cy="30" fill="#888888" r="1" />
        <circle cx="5" cy="30" fill="#888888" r="1" />
    </svg>
);
export default VerticalDots;
